import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { QrResolveResult } from '../types';

export const globalScannerApi = {
  resolve: (code: string) =>
    apiClient
      .get<QrResolveResult>(API_ENDPOINTS.QR_RESOLVE, { code })
      .then((r) => r.data)
};
